import React, { useEffect, useState, useCallback } from 'react';
import api from '../api';
import { Header } from './Dashboard';

export default function Deletions() {
  const [requests, setRequests] = useState([]);

  const load = useCallback(async () => {
    const d = await api.get('/admin/deletion-requests');
    setRequests(d.requests);
  }, []);
  useEffect(() => { load(); }, [load]);

  const setStatus = async (id, status) => {
    await api.patch(`/admin/deletion-requests/${id}`, { status });
    load();
  };

  const pending = requests.filter((r) => r.status === 'pending').length;

  return (
    <div>
      <Header title="Account Deletion Requests" sub={`${pending} pending · submitted from the website`} />
      <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
        <table>
          <thead>
            <tr><th>Account (phone/email)</th><th>Reason</th><th>Status</th><th>Requested</th><th>Actions</th></tr>
          </thead>
          <tbody>
            {requests.map((r) => (
              <tr key={r._id}>
                <td style={{ color: '#fff', fontWeight: 700 }}>{r.identifier}</td>
                <td>{r.reason || '—'}</td>
                <td>
                  <span className={`badge ${r.status === 'done' ? 'active' : r.status === 'rejected' ? 'blocked' : 'suspended'}`}>{r.status}</span>
                </td>
                <td>{new Date(r.createdAt).toLocaleString()}</td>
                <td>
                  <div style={{ display: 'flex', gap: 6 }}>
                    {r.status !== 'done' ? <button className="btn sm green" onClick={() => setStatus(r._id, 'done')}>Mark done</button> : null}
                    {r.status === 'pending' ? <button className="btn sm danger" onClick={() => setStatus(r._id, 'rejected')}>Reject</button> : null}
                  </div>
                </td>
              </tr>
            ))}
            {requests.length === 0 ? <tr><td colSpan={5} style={{ textAlign: 'center', padding: 30 }}>No deletion requests.</td></tr> : null}
          </tbody>
        </table>
      </div>
    </div>
  );
}
